import PropTypes from 'prop-types';

/**
 * Indicador personalizado para react-select que permite borrar la selección.
 */
function ClearIndicator(props) {
  const {
    children = 'Borrar todo',
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props)}>
      <div style={{ padding: '0px 5px' }}>{children}</div>
    </div>
  );
}

ClearIndicator.propTypes = {
  children: PropTypes.node,
  getStyles: PropTypes.func.isRequired,
  innerProps: PropTypes.shape({
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }).isRequired,
};

export default ClearIndicator;
